import * as React from "react";
import { Box, Typography, Button, Dialog, DialogContent } from "@mui/material";
import cartIcon from '../assets/svg/AddtoCartIcon.svg';
import { useNavigate } from "react-router-dom";

function MessagePopUp({ isOpen, onClose, message }) {
  const navigate = useNavigate()
  return (
    <Dialog open={isOpen}
      onClose={onClose}
      aria-labelledby="product-request-dialog"
      maxWidth="sm" fullWidth
      sx={{ '& .MuiDialog-paper': { maxWidth: 700, boxShadow: 2, borderRadius: "16px", height: 290 }, }}>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 2, borderRadius: 6 }}>
          <Box component="img" src={cartIcon} alt="Notification icon"
            sx={{ width: 50, height: 50, objectFit: "contain", }} loading="lazy" />
          <Typography align="center" sx={{ mt: 2, fontSize: 15, fontWeight: 600 }}>
            {message.title}
          </Typography>
          <Typography align="center" sx={{ mt: 2, fontSize: 13, fontWeight: 300 }}>
            {message.description}
          </Typography>
          <Button variant="contained" onClick={() => navigate(-1)}
            //  sx={buttonstyle}
            sx={{
              mt: 4, bgcolor: "rgba(255, 183, 3, 1)", color: "rgba(7, 42, 200, 1)", borderRadius: 2, textTransform: "uppercase",
              "&:hover": { bgcolor: "primary.dark", },
            }}
            aria-label={message.buttonText}>
            {message.buttonText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
export default MessagePopUp;